/**
 * Registry of the feature flags the frontend knows about.
 *
 * The string values MUST match the flag names configured in Unleash. This is
 * the only place a flag name is spelled out as a raw string — everywhere else,
 * reference `FeatureFlag.<Name>`.
 *
 * Flags share one Unleash project across apps, so names are namespaced by the
 * part of the product they gate (`agents.*`, `redesign.*`).
 */
export const FeatureFlag = {
  /**
   * Gates the redesign, which replaces the app shell as well as page content —
   * the project list today, more routes as they land. Defaults to off; the old
   * pages render until this is switched on in Unleash per environment.
   */
  AppRedesign: 'redesign.app.is-enabled',
  /**
   * Gates attaching context to an Agent Chat question - the composer's plus
   * CTA and its menu, the add-context modal, the attachment chips, and the Add
   * to Chat CTA on a findings card. Defaults to off, which leaves the chat as
   * it was: a question carries no context, and an answer's sources open in the
   * small document popup rather than the sources list.
   */
  PropChatContext: 'agents.prop-chat.is-context-enabled',
} as const;

/** Union of the known flag names. */
export type FeatureFlagName = (typeof FeatureFlag)[keyof typeof FeatureFlag];
